export {
  default,
  default as ImportedSyncEntityTable,
} from "./ImportedSyncEntityTable";
